import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getProfileQueryKey } from 'features/users/queries';
import { confirmTimezone } from '../services';

type ConfirmTimezoneVariables = {
  timeZone: string;
  userId: string;
};

export const useConfirmTimezone = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, ConfirmTimezoneVariables, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async mutationFn({ timeZone, userId }) {
      await confirmTimezone(userId, timeZone);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
